import {
  OverallRiskIndicator,
  RiskDimensionConfig
} from "../../../../types/risk-analysis";

export const RISK_SCORE_COLORS: Record<number, string> = {
  1: "#22c55e",
  2: "#eab308",
  3: "#FFB300",
  4: "#ef4444",
  5: "#ef4444"
};

export const RISK_LEVEL_COLORS: Record<OverallRiskIndicator, string> = {
  HIGH: "#ef4444",
  MODERATE: "#FFB300",
  MEDIUM: "#FFB300",
  LOW: "#22c55e",
  UNKNOWN: "#6b7280"
};

export const RISK_DIMENSIONS: RiskDimensionConfig[] = [
  { id: "financial", name: "Financial", riskTypeKey: "financialRisk" },
  { id: "compliance", name: "Compliance", riskTypeKey: "complianceRisk" },
  { id: "operational", name: "Operational", riskTypeKey: "operationalRisk" },
  { id: "reputational", name: "Reputational", riskTypeKey: "reputationalRisk" }
];

export const SCORE_SEGMENTS = [1, 2, 3, 4, 5] as const;

export const MAX_COLLAPSED_JUSTIFICATION_LENGTH = 120;

export const UNFILLED_COLOR = "#e5e7eb";

export const LEVEL_FROM_SCORE: Record<number, OverallRiskIndicator> = {
  1: "LOW",
  2: "LOW",
  3: "MODERATE",
  4: "HIGH",
  5: "HIGH"
};

export const getScoreColor = (score: number): string =>
  RISK_SCORE_COLORS[score] ?? RISK_SCORE_COLORS[5];

export const getRiskLevelColor = (level: OverallRiskIndicator): string =>
  RISK_LEVEL_COLORS[level] ?? "#6b7280";

export const getLevelFromScore = (score: number): OverallRiskIndicator =>
  LEVEL_FROM_SCORE[score] ?? "LOW";
